import { render, staticRenderFns } from "./legalSubject.vue?vue&type=template&id=3ce9f4d6&scoped=true&"
import script from "./legalSubject.vue?vue&type=script&lang=js&"
export * from "./legalSubject.vue?vue&type=script&lang=js&"
import style0 from "./legalSubject.vue?vue&type=style&index=0&id=3ce9f4d6&prod&scoped=true&lang=css&"
import style1 from "./legalSubject.vue?vue&type=style&index=1&id=3ce9f4d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce9f4d6",
  null
  
)

export default component.exports